import type React from 'react';

export const TikTokPlayer: React.FC<Props> = ({ playerUrl, title }) => {
	return (
		<iframe
			src={playerUrl}
			title={title}
			className="h-full w-full border-0"
			allow="autoplay; encrypted-media; fullscreen; picture-in-picture"
			allowFullScreen
			referrerPolicy="strict-origin-when-cross-origin"
		/>
	);
};

type Props = {
	playerUrl: string;
	title: string;
};
